import React from 'react';
import BreadcrumbContextProvider from '../navigation/BreadcrumbContext';
import SportBreadcrumb from '../navigation/SportBreadcrumb';
import { PrematchContext } from '../Prematch';

function CategoryMenuNavbar(props) {
    const prematchContext = React.useContext(PrematchContext);
    
    function handleGoBack() {
        prematchContext.openMenu();
    }

    return (
        <>
            <nav id="nav-go-back" className="nav-go-back">
                <div className="arrow-container" onClick={handleGoBack}>
                    <div className="arrow arrow-left"></div>
                </div>
                <div className="title-container">
                    <span className="nav-section-title" id="nav-section-title">
                        <BreadcrumbContextProvider>
                            <SportBreadcrumb desc={props.sport.descrizione} sports={prematchContext.data.sport} selected={props.sport.id} />
                        </BreadcrumbContextProvider>
                    </span>
                </div>
            </nav>
        </>
    );
}

export default CategoryMenuNavbar;